import { render, staticRenderFns } from "./TextMessage.vue?vue&type=template&id=cfa581dc&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"
import style0 from "./TextMessage.vue?vue&type=style&index=0&id=cfa581dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa581dc",
  null
  
)

export default component.exports